const isEnabled = (value: unknown) => value === true || value === 'true';

const featureFlags = {
    webRequestConsoleEnabled:
        isEnabled(window.RUNTIME_CONFIG?.webRequestConsoleEnabled) ||
        process.env.REACT_APP_WEB_REQUEST_CONSOLE_ENABLED === 'true'
};

export default featureFlags;
